import { render, staticRenderFns } from "./DuplicatePosition.vue?vue&type=template&id=d6ae7dc4"
import script from "./DuplicatePosition.vue?vue&type=script&lang=js"
export * from "./DuplicatePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports